import HeaderMain from "../../../Compoents/HeaderMain";
import BreadcrumbArea from "../../../ShearOne/BreadcrumbArea";
import FooterWhite from "../../../Compoents/FooterWhite";
import { Link } from "react-router-dom";
import MedicalServiceCards from "./MedicalServiceCards";
import MedicalJourneyProcess from "./MedicalJourneyProcess";
import MedicalTourismBeneficiaries from "./MedicalTourismBeneficiaries";
// import MedicalSpecialties from "./MedicalSpecialties";
import ServiceCards from "./ServiceCards";
// import CTASection from "./CTASection";

export const MedicalTourismDetails = () => {
  const breadcrumbLinks = [
    { path: "/", label: "Home" },
    { label: "Medical Tourism", active: true },
  ];
  return (
    <>
      <HeaderMain />
      <main>
        <BreadcrumbArea
          title="Medical Tourism"
          backgroundImage="/assets/imgs/breadcrumb/medical_tourism.jpg"
          links={breadcrumbLinks}
        />
        <section class="service-details section-space">
          <div class="container">
            {/* <h4 className="section__title mb-0 text-capitalize title-animation ">
              SQUARE MEDTECH team is a mixture of trained healthcare
              professionals with Cardiovascular Medicine (Cath-Lab specialty),
              Ultra-sonography, Dentistry, Orthopedic Surgery, General
              Practitioners, Nurse, multidisciplinary clinical specialists and
              with Engineering professional backgrounds for MedTech development.
              Our team of experienced professionals brings together a wealth of
              knowledge and expertise in clinical research, regulatory affairs,
              data management, and patient care. We are partnered with multiple
              hospitals for MedTech development. So, we have full efficiency to
              handle professionally international patients who want to receive
              medical care service under our Medical Tourism facilities with our
              affiliated hospitals.
            </h4> */}
            <div class="row flex-xl-row flex-column-reverse">
              <div class="col-xl-4">
                <div class="sidebar sidebar-rr-sticky">
                  <div class="sidebar__widget-service mb-30">
                    <Link to="/service">
                      Medical Device Manufacturers{" "}
                      <i class="fa-solid fa-plus"></i>
                    </Link>
                    <Link to="/pharmaceutical-details">
                      Pharmaceutical & Biotech industry
                      <i class="fa-solid fa-plus"></i>
                    </Link>
                    <Link to="/healthcare-details">
                      Healthcare Providers <i class="fa-solid fa-plus"></i>
                    </Link>
                  </div>

                  <div class="sidebar__widget-contact__service text-center">
                    <h4 class="mb-25 title-animation text-capitalize">
                      Are You ready to contact with us
                    </h4>
                    <p class="mb-20">
                      <a href="tel:+86 19811976744">
                        <i class="fa-solid fa-phone"></i>(+86) 19811976744
                      </a>
                    </p>
                    <Link to="/contact-us#" class="rr-btn">
                      <span class="btn-wrap">
                        <span class="text-one">
                          Contact Us <i class="fa-solid fa-plus"></i>
                        </span>
                        <span class="text-two">
                          Contact Us <i class="fa-solid fa-plus"></i>
                        </span>
                      </span>
                    </Link>
                  </div>
                </div>
              </div>
              <div class="col-xl-8">
                <div class="service-details__content">
                  <div class="service-details__content-media mb-20">
                    <img
                      src="./assets/imgs/breadcrumb/medical_tourism1.jpg"
                      class="img-fluid"
                      alt="img not found"
                    />
                  </div>

                  <h2 class="title-animation mb-20">Medical Tourism</h2>
                  <p class="mb-30">
                    SQUARE MEDTECH professionally facilitates medical tourism by
                    acting as a dedicated international patient concierge,
                    seamlessly connecting global patients with the advanced
                    medical expertise. The team provides comprehensive,
                    end-to-end support, expertly managing every detail from
                    initial inquiries, treatment planning, and cost estimates to
                    intricate visa assistance, travel logistics, accommodation
                    arrangements, in-country transportation, language
                    interpretation, and dedicated hospital coordination. By
                    leveraging, SQUARE MEDTECH renowned healthcare network and
                    offering personalized, culturally sensitive guidance, SQUARE
                    MEDTECH ensures a smooth, efficient, and trustworthy medical
                    journey, enabling patients to focus solely on their health
                    and recovery while accessing high-quality, cost-effective
                    care.
                  </p>
                  <h3 class="title-animation mb-20 content-center">
                    Our Medical Tourism Services
                  </h3>
                  <MedicalServiceCards />

                  <MedicalJourneyProcess />

                  <MedicalTourismBeneficiaries />
                  {/* <h3 className="fw-bold mb-4 pt-5">Families Seeking Comprehensive Care</h3>
                    <p class="mb-30">Families needing coordinated medical services for multiple family members or specialized pediatric care.
                    </p> */}
                  {/* <MedicalSpecialties/> */}
                  <OurTherapeuticSpecialties />

                  <ServiceCards />
                </div>
              </div>
            </div>
          </div>
        </section>
      </main>

      {/* <CTASection /> */}

      <section class="footer__cta footer__cta-bottom-up">
        <div class="container">
          <div class="row mb-minus-30">
            <div class="col-md-6">
              <div class="footer__cta-item mb-30 theme-bg-primary d-flex flex-lg-row flex-column align-items-lg-center">
                <div class="footer__cta-item-icon d-flex align-items-center justify-content-center">
                  <img
                    class="img-fluid"
                    src="/assets/imgs/footer__cta/footer__cta-item-1.png"
                    alt="icon not found"
                  />
                </div>

                <div class="footer__cta-item-text">
                  <h4 class="color-white mb-15 mb-10">
                    Our Consulting Service for Medical Tourism
                  </h4>
                  <ul class="color-white mb-0">
                    <li>Pre-treatment evaluations</li>
                    <li>Personalized treatment plans</li>
                    <li>Post-treatment follow-up</li>
                  </ul>
                </div>
              </div>
            </div>

            <div class="col-md-6">
              <div class="footer__cta-item mb-30 theme-bg-glow d-flex flex-lg-row flex-column align-items-lg-center">
                <div class="footer__cta-item-icon d-flex align-items-center justify-content-center">
                  <img
                    class="img-fluid"
                    src="/assets/imgs/footer__cta/footer__cta-item-2.png"
                    alt="icon not found"
                  />
                </div>

                <div class="footer__cta-item-text">
                  <h4 class="color-white mb-15 mb-10">
                    Our Consulting Service for Medical Tourism
                  </h4>
                  <ul class="color-white mb-0">
                    <li>Multilingual patient advocacy</li>
                    <li>Telemedicine consultancy</li>
                    <li>Multi-disciplinary care coordination</li>
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      <FooterWhite />
    </>
  );
};

export const OurTherapeuticSpecialties = () => {
  return (
    <>
      <div>
        <h3 className="rr-section-title ">Medical Specialties We Cover</h3>
        <p className="">
          Comprehensive healthcare services with world-class medical expertise
        </p>
      </div>
      <div className="successfull-experience">
        <div className="successfull-body container">
          <div className="row my-4">
            <div className="col-12">
              <div className="row justify-content-between">
                <div className="col-lg-3 col-md-4 col-sm-6 mb-4">
                  <div className="succ-experi-box text-center">
                    <div className="count">
                      <h1>01</h1>
                    </div>
                    <img
                      src="assets/imgs/slider-text/1. Cardiovascular.png"
                      style={{
                        width: "85px",
                        height: "85px",
                        display: "inline-block",
                      }}
                      alt="CLINICALR"
                    />
                    <p>Cardiology</p>
                  </div>
                </div>

                <div className="col-lg-3 col-md-4 col-sm-6 mb-4">
                  <div className="succ-experi-box text-center">
                    <div className="count">
                      <h1>02</h1>
                    </div>
                    <img
                      src="assets/imgs/slider-text/2. Vascular.png"
                      style={{
                        width: "85px",
                        height: "85px",
                        display: "inline-block",
                      }}
                      alt="coronary"
                    />
                    <p>Respiratory</p>
                  </div>
                </div>

                <div className="col-lg-3 col-md-4 col-sm-6 mb-4">
                  <div className="succ-experi-box text-center">
                    <div className="count">
                      <h1>03</h1>
                    </div>
                    <img
                      src="assets/imgs/slider-text/3. Medical Imaging.png"
                      style={{
                        width: "85px",
                        height: "85px",
                        display: "inline-block",
                      }}
                      alt="precutaneous"
                    />
                    <p>Gastroenterology</p>
                  </div>
                </div>

                <div className="col-lg-3 col-md-4 col-sm-6 mb-4">
                  <div className="succ-experi-box text-center">
                    <div className="count">
                      <h1>04</h1>
                    </div>
                    <img
                      src="assets/imgs/slider-text/4. Oral Care.png"
                      style={{
                        width: "85px",
                        height: "85px",
                        display: "inline-block",
                      }}
                      alt="coronary"
                    />
                    <p>Hematology</p>
                  </div>
                </div>
              </div>

              <div className="row justify-content-between">
                <div className="col-lg-3 col-md-4 col-sm-6 mb-4">
                  <div className="succ-experi-box text-center">
                    <div className="count">
                      <h1>05</h1>
                    </div>
                    <img
                      src="assets/imgs/slider-text/5. Surgical.png"
                      style={{
                        width: "85px",
                        height: "85px",
                        display: "inline-block",
                      }}
                      alt="pacemaker"
                    />
                    <p>Neurology</p>
                  </div>
                </div>
                <div className="col-lg-3 col-md-4 col-sm-6 mb-4">
                  <div className="succ-experi-box text-center">
                    <div className="count">
                      <h1>06</h1>
                    </div>
                    <img
                      src="assets/imgs/slider-text/6. Orthopedics.png"
                      style={{
                        width: "85px",
                        height: "85px",
                        display: "inline-block",
                      }}
                      alt="CLINICALR"
                    />
                    <p>Nephrology</p>
                  </div>
                </div>

                <div className="col-lg-3 col-md-4 col-sm-6 mb-4">
                  <div className="succ-experi-box text-center">
                    <div className="count">
                      <h1>07</h1>
                    </div>
                    <img
                      src="assets/imgs/slider-text/7. Respiratory Care.png"
                      style={{
                        width: "85px",
                        height: "85px",
                        display: "inline-block",
                      }}
                      alt="coronary"
                    />
                    <p>Oncology</p>
                  </div>
                </div>

                <div className="col-lg-3 col-md-4 col-sm-6 mb-4">
                  <div className="succ-experi-box text-center">
                    <div className="count">
                      <h1>08</h1>
                    </div>
                    <img
                      src="assets/imgs/slider-text/8. Wound Care.png"
                      style={{
                        width: "85px",
                        height: "85px",
                        display: "inline-block",
                      }}
                      alt="precutaneous"
                    />
                    <p>Eye Surgery</p>
                  </div>
                </div>
              </div>

              <div className="row justify-content-between">
                <div className="col-lg-3 col-md-4 col-sm-6 mb-4">
                  <div className="succ-experi-box text-center">
                    <div className="count">
                      <h1>09</h1>
                    </div>
                    <img
                      src="assets/imgs/slider-text/9. Oncology.png"
                      style={{
                        width: "85px",
                        height: "85px",
                        display: "inline-block",
                      }}
                      alt="coronary"
                    />
                    <p>Dental Surgery</p>
                  </div>
                </div>

                <div className="col-lg-3 col-md-4 col-sm-6 mb-4">
                  <div className="succ-experi-box text-center">
                    <div className="count">
                      <h1>10</h1>
                    </div>
                    <img
                      src="assets/imgs/slider-text/10. Neurology.png"
                      style={{
                        width: "85px",
                        height: "85px",
                        display: "inline-block",
                      }}
                      alt="pacemaker"
                    />
                    <p>Ear Surgery</p>
                  </div>
                </div>
                <div className="col-lg-3 col-md-4 col-sm-6 mb-4">
                  <div className="succ-experi-box text-center">
                    <div className="count">
                      <h1>11</h1>
                    </div>
                    <img
                      src="assets/imgs/slider-text/11. Nephrology.png"
                      style={{
                        width: "85px",
                        height: "85px",
                        display: "inline-block",
                      }}
                      alt="CLINICALR"
                    />
                    <p>Orthopedics</p>
                  </div>
                </div>

                <div className="col-lg-3 col-md-4 col-sm-6 mb-4">
                  <div className="succ-experi-box text-center">
                    <div className="count">
                      <h1>12</h1>
                    </div>
                    <img
                      src="assets/imgs/slider-text/12. Urology.png"
                      style={{
                        width: "85px",
                        height: "85px",
                        display: "inline-block",
                      }}
                      alt="coronary"
                    />
                    <p>Traditional Chinese Medicine</p>
                  </div>
                </div>

                <div className="col-lg-3 col-md-4 col-sm-6 mb-4">
                  <div className="succ-experi-box text-center">
                    <div className="count">
                      <h1>13</h1>
                    </div>
                    <img
                      src="assets/imgs/slider-text/13. Vestibular.png"
                      style={{
                        width: "85px",
                        height: "85px",
                        display: "inline-block",
                      }}
                      alt="precutaneous"
                    />
                    <p>Pediatric Surgery</p>
                  </div>
                </div>

                <div className="col-lg-3 col-md-4 col-sm-6 mb-4">
                  <div className="succ-experi-box text-center">
                    <div className="count">
                      <h1>14</h1>
                    </div>
                    <img
                      src="assets/imgs/slider-text/14. Temperature Device.png"
                      style={{
                        width: "85px",
                        height: "85px",
                        display: "inline-block",
                      }}
                      alt="coronary"
                    />
                    <p>Gynecology</p>
                  </div>
                </div>

                <div className="col-lg-3 col-md-4 col-sm-6 mb-4">
                  <div className="succ-experi-box text-center">
                    <div className="count">
                      <h1>15</h1>
                    </div>
                    <img
                      src="assets/imgs/slider-text/15. Pharmaceutical & Biotech.png"
                      style={{
                        width: "85px",
                        height: "85px",
                        display: "inline-block",
                      }}
                      alt="pacemaker"
                    />
                    <p>Cosmetic Surgery</p>
                  </div>
                </div>
                <div className="col-lg-3 col-md-4 col-sm-6 mb-4">
                  <div className="succ-experi-box text-center">
                    <div className="count">
                      <h1>16</h1>
                    </div>
                    <img
                      src="assets/imgs/slider-text/Biotech.png"
                      style={{
                        width: "85px",
                        height: "85px",
                        display: "inline-block",
                      }}
                      alt="pacemaker"
                    />
                    <p>Stem Cell Therapy </p>
                  </div>
                </div>
                <div className="col-lg-3 col-md-4 col-sm-6 mb-4">
                  <div className="succ-experi-box text-center">
                    <div className="count">
                      <h1>17</h1>
                    </div>
                    <img
                      src="assets/imgs/slider-text/Biotech.png"
                      style={{
                        width: "85px",
                        height: "85px",
                        display: "inline-block",
                      }}
                      alt="pacemaker"
                    />
                    <p>IVF </p>
                  </div>
                </div>

                <div className="col-lg-3 col-md-4 col-sm-6 mb-4">
                  <div className="succ-experi-box text-center">
                    <div className="count">
                      <h1>18</h1>
                    </div>
                    <img
                      src="assets/imgs/slider-text/Biotech.png"
                      style={{
                        width: "85px",
                        height: "85px",
                        display: "inline-block",
                      }}
                      alt="pacemaker"
                    />
                    <p>Rehabilitation </p>
                  </div>
                </div>

                <div className="col-lg-3 col-md-4 col-sm-6 mb-4">
                  <div className="succ-experi-box text-center">
                    <div className="count">
                      <h1>19</h1>
                    </div>
                    <img
                      src="assets/imgs/slider-text/Biotech.png"
                      style={{
                        width: "85px",
                        height: "85px",
                        display: "inline-block",
                      }}
                      alt="pacemaker"
                    />
                    <p>Geriatrics </p>
                  </div>
                </div>

                <div className="col-lg-3 col-md-4 col-sm-6 mb-4">
                  <div className="succ-experi-box text-center">
                    <div className="count">
                      <h1>20</h1>
                    </div>
                    <img
                      src="assets/imgs/slider-text/Biotech.png"
                      style={{
                        width: "85px",
                        height: "85px",
                        display: "inline-block",
                      }}
                      alt="pacemaker"
                    />
                    <p>Wound Care </p>
                  </div>
                </div>
              </div>
            </div>
          </div>

          {/* <p className='text-white'>
          Our expertise ensures tailored solutions for each specialty, optimizing patient outcomes and enhancing clinical practices. We stay at the forefront of medical advancements to provide cutting-edge consulting services.
          </p> */}
        </div>
      </div>
    </>
  );
};
